import { Group, Identifiable, ProjectResource, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeResourceFromProjectResourceGroup(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<ProjectResource>,
    group: Identifiable<Group>,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projectResourceGroups/${group.uuid}/resources/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

function removeResourceFromPlanzoneResourceGroup(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Resource>, group: Identifiable<Group>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzoneResourceGroups/${group.uuid}/resources/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

function removeResourceFromResourceGroup(httpClient: HttpClient) {
  return (resource: any, group: Identifiable<Group>) =>
    group.resourceType === "project"
      ? removeResourceFromProjectResourceGroup(httpClient)(resource, group)
      : removeResourceFromPlanzoneResourceGroup(httpClient)(resource, group);
}

export { removeResourceFromResourceGroup };
